import abstractGettext from './abstractGettext';

export default (input: string) => {
    return abstractGettext(navigator.language, input);
};
